import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { authApi } from "./apis/authApi";
import { usersApi } from "./apis/usersApi";
import { authSlice } from "./features/authSlice";
import { devicesApi } from "./apis/devicesApi";
import { latestDataApi } from "./apis/latestDataApi";
import { internalTempDataApi } from "./apis/internalTempDataApi";
import { externalTempDataApi } from "./apis/externalTempDataApi";
import { batteryVoltageDataApi } from "./apis/batteryVoltageDataApi";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [devicesApi.reducerPath]: devicesApi.reducer,
    [latestDataApi.reducerPath]: latestDataApi.reducer,
    [internalTempDataApi.reducerPath]: internalTempDataApi.reducer,
    [externalTempDataApi.reducerPath]: externalTempDataApi.reducer,
    [batteryVoltageDataApi.reducerPath]: batteryVoltageDataApi.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(usersApi.middleware)
      .concat(devicesApi.middleware)
      .concat(latestDataApi.middleware)
      .concat(internalTempDataApi.middleware)
      .concat(externalTempDataApi.middleware)
      .concat(batteryVoltageDataApi.middleware),
  devTools: true
});

setupListeners(store.dispatch);

export { useTryLoginMutation, useTryRegisterMutation } from "./apis/authApi";
export { logout, selectToken, selectCurrentUser } from "./features/authSlice";

export {
  useLoadAllUsersQuery,
  useDeleteUserMutation,
  useAddUserMutation
} from "./apis/usersApi";

export {
  useAddDeviceMutation,
  useDeleteDeviceMutation,
  useLoadAllDevicesQuery,
  useModifyDeviceMutation
} from "./apis/devicesApi";

export { useLoadLatestTempDataQuery } from "./apis/latestDataApi";
export { useLoadInternalTempDataMutation } from "./apis/internalTempDataApi";
export { useLoadExternalTempDataMutation } from "./apis/externalTempDataApi";
export {
  useLoadBatteryVoltageDataMutation
} from "./apis/batteryVoltageDataApi";

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
